import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './overlayWidgets.css';
import { createFastDomNode } from '../../../../base/browser/fastDomNode.js';
import { PartFingerprints, ViewPart } from '../../view/viewPart.js';
export var ViewOverlayWidgets = /*#__PURE__*/function (_ViewPart) {
  _inherits(ViewOverlayWidgets, _ViewPart);

  var _super = _createSuper(ViewOverlayWidgets);

  function ViewOverlayWidgets(context) {
    var _this;

    _classCallCheck(this, ViewOverlayWidgets);

    _this = _super.call(this, context);
    var options = _this._context.configuration.options;
    var layoutInfo = options.get(117
    /* layoutInfo */
    );
    _this._widgets = {};
    _this._verticalScrollbarWidth = layoutInfo.verticalScrollbarWidth;
    _this._minimapWidth = layoutInfo.minimap.minimapWidth;
    _this._horizontalScrollbarHeight = layoutInfo.horizontalScrollbarHeight;
    _this._editorHeight = layoutInfo.height;
    _this._editorWidth = layoutInfo.width;
    _this._domNode = createFastDomNode(document.createElement('div'));
    PartFingerprints.write(_this._domNode, 4
    /* OverlayWidgets */
    );

    _this._domNode.setClassName('overlayWidgets');

    return _this;
  }

  _createClass(ViewOverlayWidgets, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ViewOverlayWidgets.prototype), "dispose", this).call(this);

      this._widgets = {};
    }
  }, {
    key: "getDomNode",
    value: function getDomNode() {
      return this._domNode;
    } // ---- begin view event handlers

  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;
      var layoutInfo = options.get(117
      /* layoutInfo */
      );
      this._verticalScrollbarWidth = layoutInfo.verticalScrollbarWidth;
      this._minimapWidth = layoutInfo.minimap.minimapWidth;
      this._horizontalScrollbarHeight = layoutInfo.horizontalScrollbarHeight;
      this._editorHeight = layoutInfo.height;
      this._editorWidth = layoutInfo.width;
      return true;
    } // ---- end view event handlers

  }, {
    key: "addWidget",
    value: function addWidget(widget) {
      var domNode = createFastDomNode(widget.getDomNode());
      this._widgets[widget.getId()] = {
        widget: widget,
        preference: null,
        domNode: domNode
      }; // This is sync because a widget wants to be in the dom

      domNode.setPosition('absolute');
      domNode.setAttribute('widgetId', widget.getId());

      this._domNode.appendChild(domNode);

      this.setShouldRender();
    }
  }, {
    key: "setWidgetPosition",
    value: function setWidgetPosition(widget, preference) {
      var widgetData = this._widgets[widget.getId()];

      if (widgetData.preference === preference) {
        return false;
      }

      widgetData.preference = preference;
      this.setShouldRender();
      return true;
    }
  }, {
    key: "removeWidget",
    value: function removeWidget(widget) {
      var widgetId = widget.getId();

      if (this._widgets.hasOwnProperty(widgetId)) {
        var widgetData = this._widgets[widgetId];
        var domNode = widgetData.domNode.domNode;
        delete this._widgets[widgetId];
        domNode.parentNode.removeChild(domNode);
        this.setShouldRender();
      }
    }
  }, {
    key: "_renderWidget",
    value: function _renderWidget(widgetData) {
      var domNode = widgetData.domNode;

      if (widgetData.preference === null) {
        domNode.unsetTop();
        return;
      }

      if (widgetData.preference === 0
      /* TOP_RIGHT_CORNER */
      ) {
        domNode.setTop(0);
        domNode.setRight(2 * this._verticalScrollbarWidth + this._minimapWidth);
      } else if (widgetData.preference === 1
      /* BOTTOM_RIGHT_CORNER */
      ) {
        var widgetHeight = domNode.domNode.clientHeight;
        domNode.setTop(this._editorHeight - widgetHeight - 2 * this._horizontalScrollbarHeight);
        domNode.setRight(2 * this._verticalScrollbarWidth + this._minimapWidth);
      } else if (widgetData.preference === 2
      /* TOP_CENTER */
      ) {
        domNode.setTop(0);
        domNode.domNode.style.right = '50%';
      }
    }
  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {// Nothing to read
    }
  }, {
    key: "render",
    value: function render(ctx) {
      this._domNode.setWidth(this._editorWidth);

      var keys = Object.keys(this._widgets);

      for (var i = 0, len = keys.length; i < len; i++) {
        var widgetId = keys[i];

        this._renderWidget(this._widgets[widgetId]);
      }
    }
  }]);

  return ViewOverlayWidgets;
}(ViewPart);